import React, { Component } from "react";
import ScrollableAnchor, { configureAnchors } from "react-scrollable-anchor";

configureAnchors({ offset: -60, scrollDuration: 400 });

import Header from "../../../components/Library/Header";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import Mission from "./Mission";
import Manifesto from "./Manifesto";
import Jobs from "./Jobs";
import Team from "./Team";

import styles from "./About.css";

class About extends Component {
  render() {
    return (
      <div className={styles.root}>
        <Header
          className={styles.aboutHeader}
          text="About Axios" />

        <Layout>
          <Sidebar className={styles.stickySidebar}>
            <a className={styles.sidebarLinks} href="#our-mission">Our Mission</a>
            <a className={styles.sidebarLinks} href="#manifesto">Manifesto</a>
            <a className={styles.sidebarLinks} href="#team">Team</a>
            <a className={styles.sidebarLinks} href="#jobs">Jobs</a>
          </Sidebar>
          <Content>
            <ScrollableAnchor id={"our-mission"}>
              <Mission />
            </ScrollableAnchor>

            <ScrollableAnchor id={"manifesto"}>
              <Manifesto />
            </ScrollableAnchor>

            <ScrollableAnchor id={"team"}>
              <Team />
            </ScrollableAnchor>

            <ScrollableAnchor id={"jobs"}>
              <Jobs />
            </ScrollableAnchor>
          </Content>
        </Layout>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/about/components/About/About.js